import { render, staticRenderFns } from "./UserCardActions.vue?vue&type=template&id=a2d80626&scoped=true"
import script from "./UserCardActions.vue?vue&type=script&lang=js"
export * from "./UserCardActions.vue?vue&type=script&lang=js"
import style0 from "./UserCardActions.vue?vue&type=style&index=0&id=a2d80626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d80626",
  null
  
)

export default component.exports